export const translationConfig = {
  common: ['Feature.Moderation', 'Common.AlertsAndOptions', 'Feature.AppealsPortal'],
  feature: 'Feature.NotApproved'
};

export default translationConfig;
